import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { ICONS } from '../_helpers/icons.constants';
import { ModalComponent } from '../shared/design-system/modal/modal.component';
import { ModalConfig } from '../shared/design-system/modal/modal.modal';
import { HowDoIVideoLinks } from '../common/commonvariables';
import {EventEmitter, Output} from "@angular/core";
import { IWatchVideoConfig ,DEFAULT_WATCH_VIDEO_CONFIG} from './watch-video-modal';
import { SharedModule } from '../shared.module';

@Component({
    selector: 'app-watch-video',
    templateUrl: './watch-video.component.html',
    styleUrls: ['./watch-video.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule, ModalComponent, SharedModule]
})
export class WatchVideoComponent implements OnInit, OnDestroy {
  param: any;
  check: any;
  UrlFeed: any;
  isShowClose: string;
  showLoading = true;
  icons = ICONS;
  private eventsSubscription: Subscription;

  @Input() events: Observable<void>;
  @Input() href: any;

  @Input() watchVideoConfig: IWatchVideoConfig = { ...DEFAULT_WATCH_VIDEO_CONFIG};
  @Output() modalClosed = new EventEmitter<void>();
  

  modalConfig: ModalConfig = {
    id: 'watch-video-modal',
    visible: false,
    size: 'lg',
    ariaLabelledBy: 'watch-video-modal-label',
    headerIconSrc: ICONS.PLAY
  };

  constructor(private translate: TranslateService) {

  }

  ngOnInit() {
    this.showLoading = true; 
    this.modalConfig = { ...this.modalConfig, title: this.translate.instant('label_watch_video') };
    if (this.events) {
      this.eventsSubscription = this.events.subscribe(() => this.showVideo());
    }
    if(this.watchVideoConfig.autoVideoModal)
    {
      this.modalConfig.title = this.translate.instant('how_it_works_videoTitle');
      this.showVideo();
    }
   this.watchVideoConfig.videoUrl= this.watchVideoConfig.videoUrl;
  }

  ngOnDestroy() {
    if (this.eventsSubscription) {
      this.eventsSubscription.unsubscribe();
    }
  }

  close(value) {
    this.check = value;
    this.setModalVisible(false);
  }

  IsvideoActive(value) {
    this.check = value;
    this.showLoading = true;
    this.setModalVisible(true);
  }

 

  showVideo() {
    this.IsvideoActive(true);
  }

  showVideofromother(value) {
    this.IsvideoActive(value);
  }

  onModalVisibleChange(visible: boolean) {
    if (!visible) {
      this.close(false);
      this.modalClosed.emit();
    }
    
  }

  onLoad(event: Event) {
    const iframe = event.target as HTMLIFrameElement;
    this.showLoading = false;
  }

  private setModalVisible(visible: boolean) {
    if (this.modalConfig.visible === visible) { return; }
    this.modalConfig = { ...this.modalConfig, visible };
  }

}



